import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Checkbox,
  useMediaQuery,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Pagination,
  Container,
  TextField,
  Divider,
  Grid,
  Tooltip,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { ReactComponent as PenIcon } from "../../../images/penIcon.svg";
import { scrutinize } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import SessionExpired from "../../popup-components/SessionExpiredPopup";
import BugDescriptionFormat from "../../../utils/BugDescriptionFormat";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";
import CommonCopy from "../../custom-components/CommonCopy";

const BugDetailsForm = ({
  editable,
  onSave,
  onCancel,
  index,
  accordianData,
  setAccordianData,
}) => {
  const [bugTitle, setBugTitle] = useState(accordianData[index]["title"]);
  const [bugDescription, setBugDescription] = useState(
    accordianData[index]["description"]
  );
  const [bugEnvironment, setBugEnvironment] = useState(
    accordianData[index]["environment"]
  );

  const [bugPriority, setBugPriority] = useState(
    accordianData[index]["priority"]
  );

  const [bugStepsToReproduce, setStepsToReproduce] = useState(
    accordianData[index]["stepsToReproduce"]
  );

  const [bugExpectedResult, setExpectedResult] = useState(
    accordianData[index]["expectedResult"]
  );
  const [bugActualResult, setActualResult] = useState(
    accordianData[index]["actualResult"]
  );
  const [bugImpact, setImpact] = useState(accordianData[index]["impact"]);
  const [bugAdditionalInfo, setAdditionalInfo] = useState(
    accordianData[index]["impact"]
  );

  const handleSave = () => {
    const updatedValues = {
      title: bugTitle,
      description: bugDescription,
      environment: bugEnvironment,
      priority: bugPriority,
      stepsToReproduce: bugStepsToReproduce,
      expectedResult: bugExpectedResult,
      actualResult: bugActualResult,
      impact: bugImpact,
    };
    setAccordianData((prevState) => {
      const savedData = [...prevState];
      const savedBug = savedData[index];
      savedBug["title"] = bugTitle;
      savedBug["description"] = bugDescription;
      savedBug["environment"] = bugEnvironment;
      savedBug["priority"] = bugPriority;
      savedBug["stepsToReproduce"] = bugStepsToReproduce;
      savedBug["expectedResult"] = bugExpectedResult;
      savedBug["actualResult"] = bugActualResult;
      savedBug["impact"] = bugImpact;
      savedBug["additionalInfo"] = bugAdditionalInfo;
      savedData[index] = savedBug;
      return savedData;
    });
    onSave(updatedValues);
  };
  const handleCancel = () => {
    setBugTitle(accordianData[index]["title"]);
    setBugDescription(accordianData[index]["description"]);
    setBugEnvironment(accordianData[index]["environment"]);
    setBugPriority(accordianData[index]["priority"]);
    setStepsToReproduce(accordianData[index]["stepsToReproduce"]);
    setExpectedResult(accordianData[index]["expectedResult"]);
    setActualResult(accordianData[index]["actualResult"]);
    setImpact(accordianData[index]["impact"]);
    setAdditionalInfo(accordianData[index]["additionalInfo"]);
    if (onCancel) onCancel();
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <>
      <Box sx={{ pl: 2, marginTop: "-30px" }}>
        {!editable && (
          <Grid container spacing={2}>
            {bugTitle && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Title
                </Typography>
                <Typography variant="body2">{bugTitle}</Typography>
              </Grid>
            )}

            {bugDescription && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Description
                </Typography>
                <Typography variant="body2">
                  {BugDescriptionFormat(bugDescription)}
                </Typography>
              </Grid>
            )}

            {bugEnvironment && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Environment Details
                </Typography>
                <Typography variant="body2">{bugEnvironment}</Typography>
              </Grid>
            )}

            {bugPriority && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Priority
                </Typography>
                <Typography variant="body2">{bugPriority}</Typography>
              </Grid>
            )}
            {bugStepsToReproduce && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Steps to Reproduce
                </Typography>
                <Typography variant="body2">{bugStepsToReproduce}</Typography>
              </Grid>
            )}

            {bugExpectedResult && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Expected Result
                </Typography>
                <Typography variant="body2">{bugExpectedResult}</Typography>
              </Grid>
            )}

            {bugActualResult && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Actual Result
                </Typography>
                <Typography variant="body2">{bugActualResult}</Typography>
              </Grid>
            )}

            {bugAdditionalInfo && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Additional Information
                </Typography>
                <Typography variant="body2">{bugAdditionalInfo}</Typography>
              </Grid>
            )}

            {bugImpact && (
              <Grid item xs={12}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    fontSize: "14px",
                    whiteSpace: "pre-line",
                    fontWeight: "bold",
                    color: "#000",
                  }}
                >
                  Impact
                </Typography>
                <Typography variant="body2">{bugImpact}</Typography>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
      <Box sx={{ marginTop: "30px" }}>
        {editable && (
          <>
            <TextField
              fullWidth
              value={bugTitle}
              label="Title"
              placeholder="Enter the Bug Title"
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
              disabled={!editable}
              onChange={(e) => setBugTitle(e.target.value)}
            />
            <TextField
              fullWidth
              value={bugDescription}
              label="Description"
              placeholder="Enter the Bug Description"
              variant="outlined"
              multiline
              rows={4}
              sx={{ mb: 2 }}
              disabled={!editable}
              onChange={(e) => setBugDescription(e.target.value)}
            />
            <TextField
              fullWidth
              label="Environment Details"
              value={bugEnvironment}
              placeholder="Enter the Environment Details"
              variant="outlined"
              multiline
              rows={3}
              sx={{ mb: 2 }}
              disabled={!editable}
              onChange={(e) => setBugEnvironment(e.target.value)}
            />

            <TextField
              fullWidth
              label="Priority"
              value={bugPriority}
              placeholder="Enter the Bug Priority"
              variant="outlined"
              disabled={!editable}
              onChange={(e) => setBugPriority(e.target.value)}
            />
            {editable && (
              <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};
const itemsPerPage = 10;

const RenderAccordionContent = ({
  items,
  page,
  checkedStates,
  expandedStates,
  handlers,
  setPage,
  showEditIcon = false,
  accordianData,
  setAccordianData,
}) => {
  const [editingStates, setEditingStates] = useState(
    Array(items.length).fill(false)
  );

  const [titles, setTitles] = useState(items.map((item) => item.title || ""));

  const currentItems = items.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );
  const allSelected =
    checkedStates.length > 0 &&
    checkedStates.slice(0, items.length).every((checked) => checked);
  const allExpanded =
    expandedStates.length > 0 &&
    expandedStates.slice(0, items.length).every((expanded) => expanded);

  const handleTitleUpdate = (index, newTitle) => {
    setTitles((prevTitles) => {
      const newTitles = [...prevTitles];
      newTitles[index] = newTitle;
      return newTitles;
    });
  };

  return (
    <AccordionDetails>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Button
            size="small"
            sx={{ textTransform: "none", color: "#49A3FF" }}
            onClick={
              allSelected
                ? handlers.handleUnselectAll
                : handlers.handleSelectAll
            }
          >
            {allSelected ? "Unselect All" : "Select All"}
          </Button>
          <Button
            size="small"
            sx={{ textTransform: "none", color: "#49A3FF" }}
            onClick={
              allExpanded
                ? handlers.handleCollapseAll
                : handlers.handleExpandAll
            }
          >
            {allExpanded ? "Collapse All" : "Expand All"}
          </Button>
        </Box>
      </Box>

      {currentItems.map((item, index) => {
        const globalIndex = (page - 1) * itemsPerPage + index;

        return (
          <Accordion
            key={globalIndex}
            expanded={expandedStates[globalIndex] || editingStates[globalIndex]}
            onChange={(event, isExpanded) => {
              if (!editingStates[globalIndex]) {
                handlers.handleChange(globalIndex)(event, isExpanded);
              }
            }}
            sx={{ width: "100%", mb: 0 }}
          >
            <AccordionSummary
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "0 16px",
                backgroundColor: checkedStates[globalIndex]
                  ? "#d6eaf8"
                  : "white",
                "& .MuiAccordionSummary-content": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            >
              {expandedStates[globalIndex] || editingStates[globalIndex] ? (
                <KeyboardArrowDownIcon />
              ) : (
                <KeyboardArrowRightIcon />
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ml: 1,
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    size="small"
                    checked={checkedStates[globalIndex]}
                    onChange={(event) =>
                      handlers.handleCheckboxChange(globalIndex, event)
                    }
                    onClick={(event) => event.stopPropagation()}
                  />
                  <Typography variant="body2">{titles[globalIndex]}</Typography>{" "}
                </Box>
                {showEditIcon && (
                  <Tooltip title="Click to edit" placement="right" arrow>
                    <Button
                      variant="text"
                      sx={{
                        ml: "auto",
                        minWidth: "40px",
                        width: "40px",
                        height: "40px",
                        padding: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        setEditingStates((prev) => {
                          const newEditingStates = [...prev];
                          newEditingStates[globalIndex] =
                            !newEditingStates[globalIndex];
                          return newEditingStates;
                        });
                      }}
                    >
                      <PenIcon style={{ width: 18, height: 18 }} />{" "}
                    </Button>
                  </Tooltip>
                )}
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ paddingLeft: "48px" }}>
              <BugDetailsForm
                editable={editingStates[globalIndex]}
                onSave={(updatedValues) => {
                  handleTitleUpdate(globalIndex, updatedValues.title);
                  setEditingStates((prev) => {
                    const newEditingStates = [...prev];
                    newEditingStates[globalIndex] = false;
                    return newEditingStates;
                  });
                  expandedStates[globalIndex] = true;
                }}
                onCancel={() => {
                  setEditingStates((prev) => {
                    const newEditingStates = [...prev];
                    newEditingStates[globalIndex] = false;
                    return newEditingStates;
                  });
                }}
                index={index}
                accordianData={accordianData}
                setAccordianData={setAccordianData}
              />
            </AccordionDetails>
          </Accordion>
        );
      })}

      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={Math.ceil(items.length / itemsPerPage)}
          page={page}
          onChange={(event, value) => setPage(value)}
        />
      </Box>
    </AccordionDetails>
  );
};

const ImportedInputBugReport = () => {
  const navigate = useNavigate();
  const { setLoadingState } = useContext(LoadingModalContext);
  const location = useLocation();
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const [bugDetails, setBugDetails] = useState(location.state.bugDetails);
  const [selectedBugDetails, setSelectedBugDetails] = useState(
    Array(bugDetails.length).fill(null)
  );
  const [enhancedBugDescriptions, setEnhancedBugDescriptions] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [bugDetailsExpanded, setBugDetailsExpanded] = useState(true);

  const [bugDetailsPage, setBugDetailsPage] = useState(1);
  const [activeThumb, setActiveThumb] = useState(null);

  const [bugDetailsCheckedStates, setBugDetailsCheckedStates] = useState(
    Array(bugDetails.length).fill(false)
  );

  const [bugDetailsExpandedStates, setBugDetailsExpandedStates] = useState(
    Array(bugDetails.length).fill(false)
  );
  const handleThumbClick = (thumbType) => {
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };
  const bugDetailsItems = Array.from(
    { length: bugDetails.length },

    (_, index) => bugDetails[index]
  );

  const handleEnhanceBugDescription = async () => {
    const validBugDetails = selectedBugDetails.filter(
      (bug) => bug && Object.keys(bug).length > 0
    );
    const totalBugs = validBugDetails.length;
    const totalDurationMs = totalBugs * 20000;
    const updatedEnhancedBugDescription = [];
    let progressHandler;
    try {
      progressHandler = handleProgressBar({
        setLoadingState,
        totalDurationMs,
      });

      const initialMsg =
        totalBugs === 1
          ? "Enhancing Bug Description"
          : "Enhancing the Description for Bug 1";
      progressHandler.start(initialMsg);

      for (let i = 0; i < totalBugs; i++) {
        const eachBugDescription = validBugDetails[i];
        if (totalBugs > 1) {
          progressHandler.updateMessage(
            `Enhancing the Description for Bug ${i + 1}`
          );
        }
        const requestData = {
          bugReportData: eachBugDescription,
          temperature: "0.5",
        };

        const enhanceBugDescriptionResponse = await scrutinize(requestData);

        // Save enhanced bug
        setEnhancedBugDescriptions((prev) => {
          const updated = [...prev];
          updated[i] = {...enhanceBugDescriptionResponse.data, id: validBugDetails[i].id, key: validBugDetails[i].key};
          return updated;
        });

        updatedEnhancedBugDescription[i] = {...enhanceBugDescriptionResponse.data, id: validBugDetails[i].id, key: validBugDetails[i].key};
      }

      await progressHandler.finishAndClose();

      navigate("/dashboard/multi-bugreports/output", {
        state: {
          ...location.state,
          multipleInputs: validBugDetails,
          multipleOutputs: updatedEnhancedBugDescription,
        },
        replace: true,
      });
    } catch (error) {
      console.error(error);
      setSessionExpiredValue(true);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      progressHandler.stop();
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const createAccordionHandlers = (
    setCheckedStates,
    setExpandedStates,
    checkedStates,
    expandedStates,
    accordianData,
    setAccordianData,
    selectedAccordianData,
    setSelectedAccordianData
  ) => ({
    handleChange: (index) => (event, isExpanded) => {
      setExpandedStates((prev) => {
        const newStates = [...prev];
        newStates[index] = isExpanded;
        return newStates;
      });
    },

    handleCheckboxChange: (index, event) => {
      event.stopPropagation();
      setCheckedStates((prevStates) => {
        const newStates = [...prevStates];
        newStates[index] = !newStates[index];
        return newStates;
      });
      const updatedSelection = [...selectedAccordianData];
      if (event.target.checked) {
        updatedSelection[index] = accordianData[index];
      } else {
        updatedSelection[index] = null;
      }
      setSelectedAccordianData(updatedSelection);
    },

    handleSelectAll: () => {
      setCheckedStates((prevStates) => {
        const newStates = Array(accordianData.length).fill(true);
        for (let i = accordianData.length; i < prevStates.length; i++) {
          newStates[i] = prevStates[i];
        }
        return newStates;
      });
      setSelectedAccordianData([...accordianData]);
    },

    handleUnselectAll: () => {
      setCheckedStates((prevStates) => {
        const newStates = Array(accordianData.length).fill(false);
        for (let i = accordianData.length; i < prevStates.length; i++) {
          newStates[i] = prevStates[i];
        }
        return newStates;
      });
      setSelectedAccordianData(Array(accordianData.length).fill(null));
    },

    handleExpandAll: () => {
      setExpandedStates((prevStates) => {
        const newStates = Array(accordianData.length).fill(true);
        for (let i = accordianData.length; i < prevStates.length; i++) {
          newStates[i] = prevStates[i];
        }
        return newStates;
      });
    },

    handleCollapseAll: () => {
      setExpandedStates((prevStates) => {
        const newStates = Array(accordianData.length).fill(false);
        for (let i = accordianData.length; i < prevStates.length; i++) {
          newStates[i] = prevStates[i];
        }
        return newStates;
      });
    },
  });

  const bugDetailsHandlers = createAccordionHandlers(
    setBugDetailsCheckedStates,
    setBugDetailsExpandedStates,
    bugDetailsCheckedStates,
    bugDetailsExpandedStates,
    bugDetails,
    setBugDetails,
    selectedBugDetails,
    setSelectedBugDetails
  );

  const handleCopyClickData = () => {
    const orderedKeys = [
      "title",
      "description",
      "environment",
      "priority",
      "stepsToReproduce",
      "expectedResult",
      "actualResult",
      "additionalInfo",
      "impact",
    ];

    const labelMap = {
      title: "Title",
      description: "Description",
      environment: "Environment Details",
      priority: "Priority",
      stepsToReproduce: "Steps to Reproduce",
      expectedResult: "Expected Result",
      actualResult: "Actual Result",
      additionalInfo: "Additional Information",
      impact: "Impact",
    };

    const selectedContent = bugDetails
      .filter((item) => item !== null)
      .map((item) =>
        orderedKeys
          .map((key) => {
            const label = labelMap[key] || key;
            const value = item[key] ?? "Not Available";
            return `${label}:\n${value}`;
          })
          .join("\n\n")
      )
      .join("\n\n");

    return selectedContent; // ✅ THIS LINE IS REQUIRED
  };

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#f6f3f2",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        overflowY: "auto",
        width: "100%",
        minHeight: "80vh",
        height: "80vh",
        position: "relative",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
        scrollbarColor: "#888 transparent",

        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      <Box
        className="bug-report-container"
        sx={{
          bgcolor: "#F6F3F2",
          minHeight: "100vh",
          p: 2,
          // maxWidth: "600px",
          justifySelf: "center",
        }}
      >
        <Container>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              // maxWidth: 600,
              margin: "0 auto",
            }}
          >
            <Box sx={{ flexGrow: 1, width: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    color: "var(--Schemes-Secondary, #000)",
                    fontFamily: "Manrope, sans-serif",
                  }}
                >
                  <Box sx={{ display: "flex" }}>
                    <AutomateIcon sx={{ mr: 1 }} />
                    <Typography variant="body2" color="text.secondary">
                      Generate detailed and insightful bug reports with ease
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <CommonAccordion
                summary={`Bug Details (${bugDetails.length})`}
                details={
                  <Box
                    sx={{
                      height: "400px",
                      overflowY: "auto",
                      paddingRight: "18px",

                      WebkitOverflowScrolling: "touch",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#888 transparent",

                      "&::-webkit-scrollbar": {
                        width: "4px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#888",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: "#555",
                      },
                    }}
                  >
                    <RenderAccordionContent
                      items={bugDetailsItems}
                      page={bugDetailsPage}
                      checkedStates={bugDetailsCheckedStates}
                      expandedStates={bugDetailsExpandedStates}
                      handlers={bugDetailsHandlers}
                      setPage={setBugDetailsPage}
                      showEditIcon={true}
                      isEnhanced={false}
                      accordianData={bugDetails}
                      setAccordianData={setBugDetails}
                      selectedAccordianData={selectedBugDetails}
                      setSelectedAccordianData={setSelectedBugDetails}
                    />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                        mb: 4,
                      }}
                    >
                      <Tooltip title="Like" arrow>
                        <Box
                          onClick={() => handleThumbClick("like")}
                          sx={{
                            cursor: "pointer",
                            marginRight: 2,
                            "&:hover": { color: "#49A3FF" },
                          }}
                        >
                          {activeThumb === "like" ? (
                            <ThumbUpIcon sx={{ fontSize: "24px" }} />
                          ) : (
                            <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} />
                          )}
                        </Box>
                      </Tooltip>

                      {/* <Tooltip title="Dislike" arrow>
                        <Box
                          onClick={() => handleThumbClick("dislike")}
                          sx={{
                            cursor: "pointer",
                            marginRight: 2,
                            "&:hover": { color: "#49A3FF" },
                          }}
                        >
                          {activeThumb === "like" ? (
                            <ThumbUpIcon sx={{ fontSize: "24px" }} />
                          ) : (
                            <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} />
                          )}
                        </Box>
                      </Tooltip> */}

                      <Tooltip title="Dislike" arrow>
                        <Box
                          onClick={() => handleThumbClick("dislike")}
                          sx={{
                            cursor: "pointer",
                            marginRight: 2,
                            "&:hover": { color: "#FF4842" },
                          }}
                        >
                          {activeThumb === "dislike" ? (
                            <ThumbDownIcon sx={{ fontSize: "24px" }} />
                          ) : (
                            <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} />
                          )}
                        </Box>
                      </Tooltip>

                      <CommonCopy contentToCopy={handleCopyClickData()} />
                    </Box>
                  </Box>
                }
                buttons={[
                  {
                    label: "Enhance Bug Description",
                    onClick: handleEnhanceBugDescription,
                    sx: { float: "right" },
                    variant: "contained",
                    disabled:
                      !selectedBugDetails.length ||
                      selectedBugDetails.every((item) => item === null),
                    // startIcon: <GenerateButton />,
                  },
                ]}
                fullScreenMode={true}
                defaultExpanded={true}
              />
            </Box>
          </Box>
        </Container>
        <Box
          component="footer"
          sx={{
            width: "100%",
            // maxWidth: "601px",
            backgroundColor: "#f6f3f2",
            textAlign: "center",
            paddingX: "5px",
            position: "fixed",
            bottom: "0",
            zIndex: "99",
            justifySelf: "center",
          }}
        >
          <Typography variant="caption" color="textSecondary">
            Use QMentisAI™ with human supervision, as with all generative AI
            tools.
          </Typography>
        </Box>
        {sessionExpiredValue && <SessionExpired />}
      </Box>
    </Box>
  );
};

export default ImportedInputBugReport;
